module.exports = __webpack_public_path__ + "media/images/dividend/img-ashley@3x-57eb0731ec93a215b22cb756b615ba79.png";